
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"d":"M19.333 10.667h-6v-6c0-.334-.333-.667-.666-.667h-1.334a.685.685 0 00-.666.667v6h-6a.685.685 0 00-.667.666v1.334c0 .375.292.666.667.666h6v6c0 .375.291.667.666.667h1.334a.685.685 0 00.666-.667v-6h6a.685.685 0 00.667-.666v-1.334c0-.333-.333-.666-.667-.666z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      